import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

export default function Navbar() {
    return (
        <motion.header
            initial={{ y: -20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay: 0.2 }}
            className="sticky top-0 inset-x-0 z-40 bg-sand-100/80 backdrop-blur-md border-b border-ink/10"
            data-testid="site-navbar"
        >
            <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-24 py-4 flex items-center justify-between">
                <Link
                    to="/"
                    className="font-display font-black text-xl tracking-tight"
                    data-testid="nav-logo"
                >
                    استطلاعات<span className="text-emerald-signal">.</span>
                </Link>
                <nav className="hidden md:flex items-center gap-10 text-sm">
                    <Link
                        to="/surveys"
                        className="hover:text-emerald-signal transition-colors"
                        data-testid="nav-surveys"
                    >
                        تصفح الاستطلاعات
                    </Link>
                    <Link
                        to="/about"
                        className="hover:text-emerald-signal transition-colors"
                        data-testid="nav-about"
                    >
                        عن المنصة
                    </Link>
                    <a
                        href="/#ai-assistant"
                        className="hover:text-emerald-signal transition-colors"
                        data-testid="nav-ai"
                    >
                        مساعد AI
                    </a>
                    <a
                        href="/#flagship"
                        className="hover:text-emerald-signal transition-colors"
                        data-testid="nav-flagship"
                    >
                        العرض المميز
                    </a>
                </nav>
            </div>
        </motion.header>
    );
}
